// extracted by mini-css-extract-plugin
module.exports = {"display":"display_display__n6DjS"};